import { messages } from '../i18n/ja';
import type { RideWarning } from '../safety/evaluate';

type Template = Record<string, string>;

/** 文言の `{名前}` を値で置き換える。 */
export function fill(template: string, values: Template): string {
  return template.replace(/\{(\w+)\}/g, (_, key: string) => values[key] ?? '');
}

/** 評価 1 件の文言。 */
export function describeWarning(warning: RideWarning): string {
  const t = messages.safety.messages;
  const values: Template = {
    s: warning.startS.toFixed(0),
    t: warning.startTime.toFixed(1),
    from: warning.startS.toFixed(0),
    to: warning.endS.toFixed(0),
    peak: warning.peak?.toFixed(2) ?? '',
    limit: warning.limit?.toFixed(1) ?? '',
  };
  return fill(t[warning.kind], values);
}

/**
 * 走行の評価（失速・G の超過）の一覧（FR-SAF-001, 002, 005, 007）。
 * レベルは、色に加えて、アイコンと文言で示す。評価が参考値であることは、見出しと注記で示す。
 */
export function SafetyPanel({
  warnings,
}: {
  readonly warnings: readonly RideWarning[] | undefined;
}) {
  const t = messages.safety;
  return (
    <section className="safety" aria-label={t.title} data-testid="safety">
      <h3 className="safety__title">{t.title}</h3>
      {warnings === undefined && <p className="placeholder">{t.empty}</p>}
      {warnings !== undefined && warnings.every((w) => w.level === 'info') && (
        <p className="safety__clean" data-testid="safety-clean">
          {t.clean}
        </p>
      )}
      {warnings !== undefined && (
        <ul className="safety__list">
          {warnings.map((warning) => (
            <li
              key={warning.id}
              className={`safety__item safety__item--${warning.level}`}
              data-level={warning.level}
              data-kind={warning.kind}
              data-testid="safety-item"
            >
              <span className="safety__badge">
                <span aria-hidden="true">{t.icons[warning.level]}</span>
                <span>{t.levels[warning.level]}</span>
              </span>
              <span>{describeWarning(warning)}</span>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
